import CachedDictionary from '../../../services/engines/CachedDictionary';

// Boards keyed by rk — lane config parsed from the Board-note body
class BoardCache extends CachedDictionary {
    _name = 'BoardCache';

    /**
     * @returns {object[]} all boards sorted on title
     */
    getAll = () => this.getKeys().map((k) => this.getKey(k)).sort((a, b) => a.title.localeCompare(b.title));

    /**
     * @param {string} title - case-insensitive board title
     * @returns {object|null}
     */
    findByTitle = (title) => this.getAll().find((b) => b.title.toLowerCase() === title.toLowerCase()) ?? null;

    /**
     * @param {string} rk
     */
    remove = (rk) => {
        delete this._data[rk];
    };
}

const boardCache = new BoardCache();
export default boardCache;
